import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Response } from '@angular/http';

import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../reducers';
import { ShoppingCartApi } from '../../services/webservice'
import { ShoppingCartActions } from './shopping-cart.actions';

import { AppActions, CheckoutActions, MessageActions, TicketQuotaActions } from '../../actions';
import { ErrorHandlerService } from '../../services/index'
import { ActivatedRoute, Router } from '@angular/router';
import { UnsafeAction } from '../../actions/UnsafeAction';

/* tslint:disable */
@Injectable()
export class ShoppingCartEffect {

	constructor(
		private updates$: Actions,
		private store: Store<AppState>,
		private shoppingCartActions: ShoppingCartActions,
		private messageActions: MessageActions,
		private ticketQuotaActions: TicketQuotaActions,
		private checkoutActions: CheckoutActions,
		private shoppingCartApi: ShoppingCartApi,
		private errorHandler: ErrorHandlerService,
		private router: Router,
		private route: ActivatedRoute
	) { }

	@Effect() initializeShoppingCart$ = this.updates$
		.ofType(AppActions.USER_LOGGED_IN)
		.map(action => this.shoppingCartActions.getMyShoppingCart())

	@Effect() createShoppingCart$ = this.updates$
		.ofType(ShoppingCartActions.CREATE_SHOPPINGCART)
		.flatMap(action => this.shoppingCartApi.createShoppingCart()
			.flatMap(newShoppingCart =>
				Observable.concat(
					[
						this.shoppingCartActions.createShoppingCartSuccess(newShoppingCart),
						this.shoppingCartActions.getDisplayShoppingCart(newShoppingCart._links.display.href)
					])
			)
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() getMyShoppingCart$ = this.updates$
		.ofType(ShoppingCartActions.GET_MY_SHOPPINGCART)
		.flatMap(action => this.shoppingCartApi.getMyShoppingCart()
			.flatMap(myShoppingCart =>
				Observable.concat(
					[
						this.shoppingCartActions.getMyShoppingCartSuccess(myShoppingCart),
						this.shoppingCartActions.getDisplayShoppingCart(myShoppingCart._links.display.href)
					])
			)
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() addTickets$ = this.updates$
		.ofType(ShoppingCartActions.ADD_TICKETS)
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.addTickets(action.payload.url, action.payload.ticketCreationDTOs)
			.flatMap(shoppingCart =>
				Observable.concat(
					[
						this.shoppingCartActions.addTicketsSuccess(shoppingCart),
						this.shoppingCartActions.getDisplayShoppingCart(shoppingCart._links.display.href)
					])
			)
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() addVisualTickets$ = this.updates$
		.ofType(ShoppingCartActions.ADD_VISUAL_TICKETS)
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.addVisualTickets(action.payload.url, action.payload.ticketCreationDTOs)
			.flatMap(shoppingCart =>
				Observable.concat(
					[
						this.shoppingCartActions.addTicketsSuccess(shoppingCart),
						this.shoppingCartActions.getDisplayShoppingCart(shoppingCart._links.display.href)
					])
			)
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() addVisualBulkTickets$ = this.updates$
		.ofType(ShoppingCartActions.ADD_VISUAL_BULK_TICKETS)
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.addVisualBulkTickets(action.payload.url, action.payload.ticketCreationDTOs)
			.flatMap(shoppingCart =>
				Observable.concat(
					[
						this.shoppingCartActions.addTicketsSuccess(shoppingCart),
						this.shoppingCartActions.getDisplayShoppingCart(shoppingCart._links.display.href)
					])
			)
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() getDisplayShoppingCart$ = this.updates$
		.ofType(ShoppingCartActions.GET_DISPLAY_SHOPPINGCART)
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.getDisplayShoppingCart(action.payload)
			.map(displayShoppingCart => this.shoppingCartActions.getDisplayShoppingCartSuccess(displayShoppingCart))
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() removeTicket$ = this.updates$
		.ofType(ShoppingCartActions.REMOVE_TICKET)
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.removeTicket(action.payload.shoppingCartSecureId, action.payload.ticketItemUuid)
			.flatMap(shoppingCart =>
				Observable.concat(
					[
						this.shoppingCartActions.removeTicketSuccess(shoppingCart),
						this.shoppingCartActions.getDisplayShoppingCart(shoppingCart._links.display.href)
					])
			)
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() removeTickets$ = this.updates$
		.ofType(ShoppingCartActions.REMOVE_TICKETS)
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.removeTickets(action.payload.url, action.payload.ticketItemUuids)
			.flatMap(shoppingCart =>
				Observable.concat(
					[
						this.shoppingCartActions.removeTicketsSuccess(shoppingCart),
						this.shoppingCartActions.getDisplayShoppingCart(shoppingCart._links.display.href)
					])
			)
		)


	@Effect() addTicketsSuccess$ = this.updates$
		.ofType(ShoppingCartActions.ADD_TICKETS_SUCCESS)
		.do(action => this.router.navigate(['/shopping-cart']))
		.map(update => this.messageActions.displayMessage("Die Karten wurden erfolgreich in den Warenkorb hinzugefügt", "success"))

	@Effect() removeTicketSuccess$ = this.updates$
		.ofType(ShoppingCartActions.REMOVE_TICKET_SUCCESS)
		.map(update => this.messageActions.displayMessage("Die Karte wurden erfolgreich aus dem Warenkorb entfernt.", "success"))

	@Effect() removeTicketsSuccess$ = this.updates$
		.ofType(ShoppingCartActions.REMOVE_TICKETS_SUCCESS)
		.map(update => this.messageActions.displayMessage("Die Karten wurden erfolgreich aus dem Warenkorb entfernt.", "success"))

	@Effect() deleteShoppingCart$ = this.updates$
		.ofType(ShoppingCartActions.DELETE_SHOPPINGCART)
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.deleteShoppingCart(action.payload)
			.flatMap(response =>
				Observable.concat([
					this.shoppingCartActions.deleteShoppingCartSuccess(),
					this.shoppingCartActions.getMyShoppingCart()
				])
			)
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() detachShoppingCart$ = this.updates$
		.ofType(ShoppingCartActions.DETACH_SHOPPINGCART)
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.detachShoppingCart(
			action.payload.url,
			action.payload.description,
			action.payload.expiration
		).flatMap(response =>
			Observable.concat([
				this.shoppingCartActions.getMyShoppingCart()
			])
		).do(x => this.router.navigate(["/shoppingCarts"]))
		.do(x => this.store.dispatch(this.shoppingCartActions.detachShoppingCartSuccess()))

		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
	)

	@Effect() attachShoppingCart$ = this.updates$
	.ofType(ShoppingCartActions.ATTACH_SHOPPINGCART)
	.flatMap((action: UnsafeAction) => this.shoppingCartApi.attachShoppingCart(action.payload)
	.flatMap(response =>
		Observable.concat([
			this.shoppingCartActions.getMyShoppingCart()
		])
	).do(x => this.router.navigate(["/shopping-cart"]))
	.do(x => this.store.dispatch(this.shoppingCartActions.attachShoppingCartSuccess()))

	.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
)

	@Effect() deleteShoppingCartSuccess$ = this.updates$
		.ofType(ShoppingCartActions.DELETE_SHOPPINGCART_SUCCESS)
		.map(action => this.messageActions.displayMessage("Warenkorb wurde erfolgreich gelöscht.", "success"))

	@Effect() detachShoppingCartSuccess$ = this.updates$
		.ofType(ShoppingCartActions.DETACH_SHOPPINGCART_SUCCESS)
		.map(action => this.messageActions.displayMessage("Warenkorb wurde erfolgreich als Reservierung gespeichert.", "success"))


	@Effect() attachShoppingCartSuccess$ = this.updates$
		.ofType(ShoppingCartActions.ATTACH_SHOPPINGCART_SUCCESS)
		.map(action => this.messageActions.displayMessage("Die Reservierung wurde in den Warenkorb übernommen", "success"))

	private handleError(error:Response, defaultMessage:string):Observable<Action> {
		let errorMessage = this.errorHandler.getErrorMessage(error,	defaultMessage)
		return Observable.of(this.messageActions.displayMessage(errorMessage, "error"))
	}

	private handleErrorAsAction(error: Response, defaultMessage: string): Action {
		let errorMessage = this.errorHandler.getErrorMessage(error, defaultMessage)
		return this.messageActions.displayMessage(errorMessage, "error");
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart.effect.ts